import Image from 'next/image';
import clsx from 'clsx';

type BrandSize = 'sm' | 'md' | 'lg' | 'xl';

const markSizes: Record<BrandSize, string> = {
    sm: 'h-8 w-8',
    md: 'h-10 w-10',
    lg: 'h-12 w-12',
    xl: 'h-20 w-20',
};

const imageSizes: Record<BrandSize, string> = {
    sm: '32px',
    md: '40px',
    lg: '48px',
    xl: '80px',
};

const textSizes: Record<BrandSize, string> = {
    sm: 'text-xl',
    md: 'text-2xl',
    lg: 'text-2xl',
    xl: 'text-3xl',
};

interface BrandMarkProps {
    size?: BrandSize;
    className?: string;
    priority?: boolean;
}

interface BrandLogoProps extends BrandMarkProps {
    showText?: boolean;
    textClassName?: string;
    gapClassName?: string;
}

export function BrandMark({ size = 'md', className, priority = false }: BrandMarkProps) {
    return (
        <span
            className={clsx(
                'relative inline-flex shrink-0 overflow-hidden rounded-full ring-1 ring-[#d4af37]/24 shadow-[0_10px_24px_rgba(212,175,55,0.12)]',
                markSizes[size],
                className
            )}
        >
            <Image
                src="/logo.png"
                alt="YourAura brand mark"
                fill
                className="object-cover"
                sizes={imageSizes[size]}
                priority={priority}
            />
        </span>
    );
}

export default function BrandLogo({
    size = 'md',
    className,
    textClassName,
    gapClassName = 'gap-2',
    showText = true,
    priority = false,
}: BrandLogoProps) {
    return (
        <span className={clsx('inline-flex items-center', gapClassName, className)}>
            <BrandMark size={size} priority={priority} />
            {showText && (
                <span
                    className={clsx(
                        'font-playfair font-bold tracking-wide text-current',
                        textSizes[size],
                        textClassName
                    )}
                >
                    YourAura
                </span>
            )}
        </span>
    );
}
